export const AUTH_METHOD = {
  COOKIE: "cookie",
  MSAL: "msal"
} as const

export type AuthMethod = (typeof AUTH_METHOD)[keyof typeof AUTH_METHOD]
